import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeVersionPage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Version d'un runtime et ses dépendances (porting README #43). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/versions/$versionId')({
  component: RuntimeVersionRoute,
});

function RuntimeVersionRoute() {
  const { tenant, runtimeId, versionId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[
        { label: t('nav.items.runtimes') },
        { label: <EntityName tenantId={tenant} kind="runtime" id={runtimeId} /> },
        {
          label: <EntityName tenantId={tenant} kind="runtimeVersion" id={versionId} scope={{ runtimeId }} />,
        },
      ]}
    >
      <RuntimeVersionPage tenantId={tenant} runtimeId={runtimeId} versionId={versionId} />
    </ConsoleShell>
  );
}
